import { BuildCircle, KeyboardArrowDown, KeyboardArrowRight } from '../../../primitives/index.ts'
import classes from './navigation-tree-node-arrow-icon.module.css'

export interface FormOverviewTreeNodeArrowProps {
  isOpen?: boolean
  isLeaf?: boolean
}

export function NavigationTreeNodeArrowIcon(props: FormOverviewTreeNodeArrowProps) {
  const { isLeaf, isOpen } = props

  return isLeaf ? (
    <BuildCircle className={classes.circle} />
  ) : isOpen ? (
    <KeyboardArrowDown className={classes.arrow} />
  ) : (
    <KeyboardArrowRight className={classes.arrow} />
  )
}
